import ActionTypes from "../Actions/ActionTypes";

let initialState = {
  PagesInformation: null,
};

const PagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PAGES_INFORMATION:
      state = { ...state, PagesInformation: action.payload };
      break;

    default:
      break;
  }
  return state;
};

export default PagesReducer;
